import { render, staticRenderFns } from "./AvvList.vue?vue&type=template&id=92bb096a&scoped=true"
import script from "./AvvList.vue?vue&type=script&lang=js"
export * from "./AvvList.vue?vue&type=script&lang=js"
import style0 from "./AvvList.vue?vue&type=style&index=0&id=92bb096a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bb096a",
  null
  
)

export default component.exports